import { formData, validateForm, Validations, bindFormValidationEvents, sendForm } from '../utils';


export function registerContactBlock(): void {
    const FORM_ID = 'contact-form';
    const VALIDATIONS: Validations = {
        phone: {
            validations: [
                {
                    message: 'Telefonnumret kan bara innehålla siffror.',
                    pattern: /^[0-9]*$/
                },
            ],
        },
        email: {
            validations: [
                {
                    message: 'E-postadressen måste innehålla @ och punkt före den sista delen (.se, .com etc).',
                    pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                },
            ],
        },
        gdpr: {
            message: 'Markera kryssrutan om du vill fortsätta.',
            required: true,
            validations: [
                {
                    message: 'Markera kryssrutan om du vill fortsätta.',
                    action(value) {
                        // Should be checked
                        return !!value;
                    }
                },
            ],
        },
    };

    const $form = document.getElementById(FORM_ID) as HTMLFormElement;

    function onFormSubmit(): void {
        // Send form
        const data = formData($form);

        if (!validateForm($form, VALIDATIONS, data)) {
            console.error('Validation failed for form');
            return;
        }

        // Force gdpr input to have value when sending the request
        const $gdpr = document.querySelector<HTMLInputElement>('#gdpr');
        const gdpr = $gdpr?.checked ?? false;

        sendForm({
            form: $form,
            type: $form.method || 'POST',
            url: $form.action,
            data: {
                gdpr,
                ...data,
            },
        });
    }

    // Initialize events
    if ($form != null) {
        // Bind form validation events
        bindFormValidationEvents($form, onFormSubmit);
    }
}
